module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('edition-input', {
    attrs: {
      "errors": _vm.errors.edition,
      "required": true
    },
    model: {
      value: (_vm.form.edition),
      callback: function($$v) {
        _vm.$set(_vm.form, "edition", $$v)
      },
      expression: "form.edition"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "images"
  }, [_vm._m(0), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Tytuł",
      "error": _vm.errors[_vm.addLanguageSuffix('left_title')]
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.form[_vm.addLanguageSuffix('left_title')]),
      callback: function($$v) {
        _vm.$set(_vm.form, _vm.addLanguageSuffix('left_title'), $$v)
      },
      expression: "form[addLanguageSuffix('left_title')]"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Kategoria",
      "error": _vm.errors['left_category']
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "placeholder": "Kategoria"
    },
    model: {
      value: (_vm.form.left_category),
      callback: function($$v) {
        _vm.$set(_vm.form, "left_category", $$v)
      },
      expression: "form.left_category"
    }
  }, _vm._l((_vm.categories), function(category) {
    return _c('el-option', {
      key: category.id,
      attrs: {
        "label": category.name_pl,
        "value": category.id
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Nazwa przycisku",
      "error": _vm.errors[_vm.addLanguageSuffix('left_button_title')]
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.form[_vm.addLanguageSuffix('left_button_title')]),
      callback: function($$v) {
        _vm.$set(_vm.form, _vm.addLanguageSuffix('left_button_title'), $$v)
      },
      expression: "form[addLanguageSuffix('left_button_title')]"
    }
  })], 1), _vm._v(" "), _c('link-component', {
    attrs: {
      "errors": _vm.errors.left_link
    },
    model: {
      value: (_vm.form.left_link),
      callback: function($$v) {
        _vm.$set(_vm.form, "left_link", $$v)
      },
      expression: "form.left_link"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "images"
  }, [_vm._m(1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Tytuł",
      "error": _vm.errors[_vm.addLanguageSuffix('right_title')]
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.form[_vm.addLanguageSuffix('right_title')]),
      callback: function($$v) {
        _vm.$set(_vm.form, _vm.addLanguageSuffix('right_title'), $$v)
      },
      expression: "form[addLanguageSuffix('right_title')]"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Kategoria",
      "error": _vm.errors['right_category']
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "placeholder": "Kategoria"
    },
    model: {
      value: (_vm.form.right_category),
      callback: function($$v) {
        _vm.$set(_vm.form, "right_category", $$v)
      },
      expression: "form.right_category"
    }
  }, _vm._l((_vm.categories), function(category) {
    return _c('el-option', {
      key: category.id,
      attrs: {
        "label": category.name_pl,
        "value": category.id
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Nazwa przycisku",
      "error": _vm.errors[_vm.addLanguageSuffix('right_button_title')]
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.form[_vm.addLanguageSuffix('right_button_title')]),
      callback: function($$v) {
        _vm.$set(_vm.form, _vm.addLanguageSuffix('right_button_title'), $$v)
      },
      expression: "form[addLanguageSuffix('right_button_title')]"
    }
  })], 1), _vm._v(" "), _c('link-component', {
    attrs: {
      "errors": _vm.errors.right_link
    },
    model: {
      value: (_vm.form.right_link),
      callback: function($$v) {
        _vm.$set(_vm.form, "right_link", $$v)
      },
      expression: "form.right_link"
    }
  })], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box__header"
  }, [_c('span', {
    staticClass: "box__header--text"
  }, [_vm._v("Lewa kolumna")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box__header"
  }, [_c('span', {
    staticClass: "box__header--text"
  }, [_vm._v("Prawa kolumna")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3e9f8269"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/widgets/forms/FoodVendorsWidget/FoodVendorsWidget.vue
// module id = 741
// module chunks = 0